module.exports = __webpack_public_path__ + "img/stripe-badge-white.ced68b78.png";